import React, { Component } from 'react';
import { object, bool, string, func, number, array } from 'prop-types';
import cn from 'classnames';
import ReportCards from '../ReportCards/ReportCards';
import ReportTable from '../ReportTable/ReportTable';
import InPlaceIndicator from '../../../LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import Placeholder from '../../../Placeholder/Placeholder';

class ReportList extends Component {
  static propTypes = {
    collections: array,
    reports: object,
    reportsLoading: bool,
    sortField: string,
    listStale: bool,
    viewType: string,
    group: object,
    reportWriterUrl: string,
    groupIdFilter: string,
    scopeFilter: string,
    userId: string,
    userReportViewer: bool,
    userEmail: string,
    groupId: string,
    reportUrl: string,
    setSortField: func,
    reportBulkSelect: func,
    launchDarklyFeatureFlags: object,
    sortReportsByType: func,
    sortDirection: string,
    noReportsStatusImage: string,
    createdByFilter: number,
    textFilter: string,
    popularFilter: bool,
    onSelectPopular: func,
    selectedPopularReports: array,
    deleteCollection: func,
    refresh: func,
    userSiteAdmin: bool,
    userGroupAdmin: bool
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  shouldComponentUpdate(nextProps) {
    if (this.props !== nextProps) {
      return true;
    }
    return false;
  }

  renderReports() {
    // only show Loading on initial load; assume ES is fast enough between queries to not
    // render Loading text
    if (!this.props.reports && this.props.reportsLoading) {
      return <InPlaceIndicator />;
    }

    let reports = (this.props.reports && this.props.reports.edges) || [];
    const collections = this.props.collections;

    if (
      reports.length < 1 ||
      (this.props.popularFilter && !this.props.reports.collectionsLoading && collections.length < 1)
    ) {
      const missingText = 'No reports found for that search term or filter';
      if (this.props.noReportsStatusImage) {
        return (
          <div style={{ height: '100%', alignItems: 'center', display: 'flex' }}>
            <Placeholder
              className="reports__results--empty"
              imagePath={this.props.noReportsStatusImage}
              secondaryText={missingText}
              showText={true}
            />
          </div>
        );
      } else {
        return <div>{missingText}</div>;
      }
    }
    const icon = !this.props.sortDirection || this.props.sortDirection === 'ASC' ? 'icon-sort-up' : 'icon-sort-down';

    if (this.props.viewType === 'card' || this.props.popularFilter) {
      return (
        <ReportCards
          collections={collections}
          reports={reports}
          userId={this.props.userId}
          userReportViewer={this.props.userReportViewer}
          userEmail={this.props.userEmail}
          launchDarklyFeatureFlags={this.props.launchDarklyFeatureFlags}
          groupId={this.props.groupId}
          reportWriterUrl={this.props.reportUrl}
          reportBulkSelect={this.props.reportBulkSelect}
          popularFilter={this.props.popularFilter}
          hiddenCollections={this.props.hiddenCollections}
          toggleCollections={this.props.toggleCollections}
          onSelectPopular={this.props.onSelectPopular}
          selectedPopularReports={this.props.selectedPopularReports}
          deleteCollection={this.props.deleteCollection}
          refresh={this.props.refresh}
          userSiteAdmin={this.props.userSiteAdmin}
          userGroupAdmin={this.props.userGroupAdmin}
        />
      );
    } else {
      return (
        <ReportTable
          reports={reports}
          reportWriterUrl={this.props.reportUrl}
          userReportViewer={this.props.userReportViewer}
          icon={icon}
          launchDarklyFeatureFlags={this.props.launchDarklyFeatureFlags}
          setSortField={this.props.setSortField}
          sortField={this.props.sortField}
          sortDirection={this.props.sortDirection}
          sortReportsByType={this.props.sortReportsByType}
          reportBulkSelect={this.props.reportBulkSelect}
          scopeFilter={this.props.scopeFilter}
          createdByFilter={this.props.createdByFilter}
          textFilter={this.props.textFilter}
          userSiteAdmin={this.props.userSiteAdmin}
          userGroupAdmin={this.props.userGroupAdmin}
        />
      );
    }
  }

  render() {
    return <div className={cn('reports__list', { popular: this.props.popularFilter })}>{this.renderReports()}</div>;
  }
}

export default ReportList;
